import { css } from 'lit'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const styles = css`
  cse-text {
    --cse-text-color: ${csColorFunctional.warning};
  }
`
